import { Navigate, Route, Routes } from 'react-router-dom'
import { RequireAuth } from '@astro/auth'
import { ToastProvider } from './context/ToastContext'
import DashboardRoute from './components/layout/DashboardRoute'
import ScrollManager from './components/common/ScrollManager'
import AccountPage from './pages/AccountPage'
import LoginPage from './pages/LoginPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import AboutPage from './pages/AboutPage'
import ContactPage from './pages/ContactPage'
import HoroscopePage from './pages/HoroscopePage'
import AstroToolsPage from './pages/AstroToolsPage'
import AstrologerRegisterPage from './pages/AstrologerRegisterPage'
import BlogPage from './pages/BlogPage'
import BlogPostPage from './pages/BlogPostPage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import RefundPolicyPage from './pages/RefundPolicyPage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import ShippingPolicyPage from './pages/ShippingPolicyPage'
import CookiePolicyPage from './pages/CookiePolicyPage'
import DisclaimerPage from './pages/DisclaimerPage'
import GrievanceRedressalPage from './pages/GrievanceRedressalPage'
import PageLayout from './components/layout/PageLayout'
import HeroSection from './components/sections/hero/HeroSection'
import HoroscopeSection from './components/sections/horoscope/HoroscopeSection'
import AboutSection from './components/sections/about/AboutSection'
import AstrologersSection from './components/sections/astrologers/AstrologersSection'
import LiveNowSection from './components/sections/liveStream/LiveNowSection'
import AcademySection from './components/sections/academy/AcademySection'
import CoursesCatalogSection from './components/sections/courses/CoursesCatalogSection'
import DivineShopSection from './components/sections/shop/DivineShopSection'
import FeaturedProductsSection from './components/sections/products/FeaturedProductsSection'
import WhyChooseSection from './components/sections/whyChoose/WhyChooseSection'
import OurExpertiseSection from './components/sections/expertise/OurExpertiseSection'
import StatsShowcaseSection from './components/sections/stats/StatsShowcaseSection'
import AboutOverviewSection from './components/sections/aboutOverview/AboutOverviewSection'
import OfferBannerSection from './components/sections/offerBanner/OfferBannerSection'
import MediaGallerySection from './components/sections/mediaGallery/MediaGallerySection'
import TestimonialsSection from './components/sections/testimonials/TestimonialsSection'
import FaqSection from './components/sections/faq/FaqSection'
import LatestInsightsSection from './components/sections/latestInsights/LatestInsightsSection'
import AstroToolsSection from './components/sections/astroTools/AstroToolsSection'
import DonationInitiativeSection from './components/sections/donationInitiative/DonationInitiativeSection'
import FacebookFeedSection from './components/sections/facebookFeed/FacebookFeedSection'
import InstagramFeedSection from './components/sections/instagramFeed/InstagramFeedSection'

function HomePage() {
  return (
    <PageLayout className="bg-astroDark text-white font-body antialiased relative overflow-x-clip">
        <div className="absolute inset-0 pointer-events-none z-0 overflow-hidden">
          <div className="absolute top-[-10%] left-[-10%] w-[90vw] sm:w-[60vw] h-[90vw] sm:h-[60vw] bg-goldGlow/25 rounded-full animate-aura" />
          <div
            className="absolute bottom-[-10%] right-[-10%] w-[80vw] sm:w-[50vw] h-[80vw] sm:h-[50vw] bg-yellow-950/10 rounded-full animate-aura"
            style={{ animationDelay: '-4s' }}
          />
        </div>

        <HeroSection />
        <LiveNowSection />
        <HoroscopeSection />
        <AboutSection />
        <AstrologersSection />
        <AcademySection />
        <CoursesCatalogSection />
        <DivineShopSection />
        <FeaturedProductsSection />
        <WhyChooseSection />
        <OurExpertiseSection />
        <StatsShowcaseSection />
        <AboutOverviewSection />
        <OfferBannerSection />
        <MediaGallerySection />
        <TestimonialsSection />
        <FaqSection />
        <LatestInsightsSection />
        <AstroToolsSection />
        <DonationInitiativeSection />
        <FacebookFeedSection />
        <InstagramFeedSection />
      </PageLayout>
  )
}

function App() {
  return (
    <ToastProvider>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/horoscope" element={<HoroscopePage />} />
        <Route path="/astro-tools" element={<AstroToolsPage />} />
        <Route path="/astrologer-register" element={<AstrologerRegisterPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        {/* ── Legal document set (pages/legal/*, all rendered by LegalPage) ── */}
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/refund-policy" element={<RefundPolicyPage />} />
        <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
        <Route path="/grievance-redressal" element={<GrievanceRedressalPage />} />
        {/* Short aliases — these are the paths people type, and the ones a
            payment-gateway or app-store listing usually asks for. */}
        <Route path="/terms" element={<Navigate to="/terms-of-service" replace />} />
        <Route path="/terms-and-conditions" element={<Navigate to="/terms-of-service" replace />} />
        <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
        <Route path="/cookies" element={<Navigate to="/cookie-policy" replace />} />
        <Route path="/refunds" element={<Navigate to="/refund-policy" replace />} />
        <Route path="/cancellation-policy" element={<Navigate to="/refund-policy" replace />} />
        <Route path="/shipping" element={<Navigate to="/shipping-policy" replace />} />
        <Route path="/shipping-and-delivery" element={<Navigate to="/shipping-policy" replace />} />
        <Route path="/grievance" element={<Navigate to="/grievance-redressal" replace />} />
        <Route path="/login" element={<LoginPage />} />
        {/* Target of the emailed reset link: /reset-password?token=…&email=… */}
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route element={<RequireAuth fallback={<div className="p-10 text-center">Checking session…</div>} />}>
          <Route path="/account" element={<AccountPage />} />
          {/* Shared dashboard inside this app's own chrome. The sticky pin
              points are measured off the real navbar (see DashboardRoute) —
              its height varies by breakpoint, so a fixed 130px left the mobile
              section bar hanging in a gap. */}
          <Route path="/dashboard" element={<DashboardRoute />} />
        </Route>
        {/* Backward-compatible aliases for the original static .html URLs */}
        <Route path="/index" element={<Navigate to="/" replace />} />
        <Route path="/about" element={<Navigate to="/about" replace />} />
        <Route path="/contact" element={<Navigate to="/contact" replace />} />
        <Route path="/horoscope" element={<Navigate to="/horoscope" replace />} />
        <Route path="/login" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
    </ToastProvider>
  )
}

export default App
